import React, { useEffect, useState } from 'react';
import axios from "axios";
import { LayersControl, MapContainer, TileLayer, useMap } from "react-leaflet";
import MapSiteMarker from "../../../Map/resources/js/MapSiteMarker";
import Qs from "qs";
import "./SiteIndexMapLeaflet.css"
import PropTypes from "prop-types";

// stolen from https://github.com/axios/axios/issues/738#issuecomment-412905574
// Format nested params correctly
axios.interceptors.request.use(config => {

    config.paramsSerializer = params => {
        // Qs is already included in the Axios package
        return Qs.stringify(params, {
            arrayFormat: "brackets",
            encode: false
        });
    };
    return config;
});

const SetCenter = (props) => {
    const {
        locations
    } = props;

    const map = useMap();
    const bounds = locations.map(location => [{'lat': location.lat, 'lng': location.lng}]);

    useEffect(() => {
        if (bounds.length) {
            map.fitBounds(bounds);
        }
    }, [bounds, map]);

    return null;
}

const SiteUserProfileIndexMap = props => {
    const {
        filter,
        advancedMap,
    } = props;

    const [locations, setLocations] = useState([]);

    useEffect(async () => {
            const { data: { data } } = await axios.get(`/api/site/`, { params: { filter } });
            setLocations(data);
    }, []);

    const onSiteSelect = (site) => {
        window.open(`/browse/site/${site.id}`, '_blank');
    }

    return (
        <div>
            <MapContainer
                id="site-index-map-container"
                zoomControl
                maxZoom={18}
                center={[43.6532, -79.3832]}
                zoom={8}
                style={{height: '400px', position: 'relative'}}
                className="mb-2 mx-2"
            >
                <LayersControl position="topright">
                    <LayersControl.BaseLayer checked name="Google Streets">
                        <TileLayer
                            url="https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"
                            subdomains={['mt0','mt1','mt2','mt3']}
                        />
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer name="Google Hybrid">
                        <TileLayer
                            url="https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}"
                            subdomains={['mt0','mt1','mt2','mt3']}
                        />
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer name="Google Satellite">
                        <TileLayer
                            url="https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}"
                            subdomains={['mt0','mt1','mt2','mt3']}
                        />
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer name="Google Terrain">
                        <TileLayer
                            url="https://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}"
                            subdomains={['mt0','mt1','mt2','mt3']}
                        />
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer name="Regular OpenStreetMap">
                        <TileLayer
                            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />
                    </LayersControl.BaseLayer>
                </LayersControl>
                {locations?.map(site => (
                    <MapSiteMarker
                        key={`site-${site.id}`}
                        site={site}
                        onSiteSelect={()=> onSiteSelect(site)}
                        isColorCoded={advancedMap}
                    />
                ))}
                {locations && <SetCenter
                    locations={locations}
                />}
            </MapContainer>
        </div>
    );
};

SiteUserProfileIndexMap.propTypes = {
    advancedMap: PropTypes.bool,
};

SiteUserProfileIndexMap.defaultProps = {
    advancedMap: false,
};

export default SiteUserProfileIndexMap;
